import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AppControllerService } from "../../../app-controller.service";
import { RequestStatusService } from "../request-status/request-status.service";
import { AuthService } from "../auth/auth.service";
import { catchError, take } from "rxjs/operators";
import { firstValueFrom, lastValueFrom, of } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ApiAttachmentUploadSessionConstants } from "../../constants/api-constants/api-attachment-upload-session.constants";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { FileConstants } from "./file.constants";
import { AlertType } from "../../models/alert";
import { SharedConstants } from "../../constants/shared.constants";
let FileService = class FileService {
    appController;
    requestStatusService;
    http;
    authService;
    authenticationToken;
    constructor(appController, requestStatusService, http, authService) {
        this.appController = appController;
        this.requestStatusService = requestStatusService;
        this.http = http;
        this.authService = authService;
        this.authService.$authenticationToken.subscribe((tokenChange) => {
            this.authenticationToken = tokenChange;
        });
    }
    uploadFile(url, formData, mergeType, source, split = false, returnFunction) {
        if (split) {
            const fileKey = "file";
            const file = formData.get(fileKey);
            const chunks = this.splitFile(file);
            const jobId = Number(formData.get("jobId"));
            const startParams = {
                fileName: file.name,
                fileSize: file.size,
                totalChunks: chunks.length,
                jobId,
                type: mergeType
            };
            this.http.post(`${ApiAttachmentUploadSessionConstants.URL}/${ApiAttachmentUploadSessionConstants.FUNCTION_START_UPLOAD}`, startParams).pipe(take(1)).subscribe({
                next: async (session) => {
                    for (let i = 0; i < chunks.length; i++) {
                        const form = new FormData();
                        form.append("uploadSessionId", session.id.toString());
                        form.append("chunkIndex", i.toString());
                        form.append("chunk", chunks[i]);
                        const result = await lastValueFrom(this.http.post(`${ApiAttachmentUploadSessionConstants.URL}/${ApiAttachmentUploadSessionConstants.FUNCTION_UPLOAD_CHUNK}`, form)
                            .pipe(catchError(error => {
                            this.appController.handleServerErrorMessage(SharedConstants.FILE_OBJECT_NAME, error, CRUDOperation.Saving);
                            return of(false);
                        })));
                        if (result === false) {
                            returnFunction(null);
                            return;
                        }
                    }
                    const mergeParams = {
                        uploadSessionId: session.id,
                        fileName: file.name,
                        totalChunks: chunks.length,
                        type: mergeType,
                        source
                    };
                    // @ts-ignore
                    for (const [key, value] of formData.entries()) {
                        if (key.toLowerCase() !== "file") {
                            mergeParams[key] = value;
                        }
                    }
                    this.http.post(`${ApiAttachmentUploadSessionConstants.URL}/${ApiAttachmentUploadSessionConstants.FUNCTION_MERGE_CHUNKS}`, mergeParams).pipe(take(1)).subscribe({
                        next: result => {
                            returnFunction(result);
                        },
                        error: (error) => {
                            this.appController.handleServerErrorMessage(SharedConstants.FILE_OBJECT_NAME, error, CRUDOperation.Saving);
                            returnFunction(null);
                        }
                    });
                    // returnFunction(result);
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage(SharedConstants.FILE_OBJECT_NAME, error, CRUDOperation.Saving);
                    returnFunction(null);
                }
            });
        }
        else {
            this.http.post(url, formData).pipe(take(1)).subscribe({
                next: (result) => {
                    returnFunction(result);
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage(SharedConstants.FILE_OBJECT_NAME, error, CRUDOperation.Saving);
                    returnFunction(null);
                }
            });
        }
    }
    splitFile(file, chunkSize = 2 * 1024 * 1024) {
        const chunks = [];
        let start = 0;
        while (start < file.size) {
            const end = Math.min(start + chunkSize, file.size);
            chunks.push(file.slice(start, end));
            start = end;
        }
        return chunks;
    }
    async download(fileUrl, chunkSize = 1 * 1024 * 1024) {
        this.requestStatusService.showBusySpinner("Download file");
        try {
            const headers = await firstValueFrom(this.http.head(fileUrl, { observe: "response" }));
            const contentLength = headers.headers.get("content-length");
            if (!contentLength) {
                this.requestStatusService.removeBusySpinner("Download file");
                this.appController.showMessage(FileConstants.HEAD_ERROR, AlertType.Error);
            }
            const totalSize = parseInt(contentLength, 10);
            const chunks = [];
            let start = 0;
            // 2. Loop through and fetch each chunk
            while (start < totalSize) {
                const end = Math.min(start + chunkSize - 1, totalSize - 1);
                const rangeHeader = new HttpHeaders().set("Range", `bytes=${start}-${end}`);
                // Fetch chunk as an ArrayBuffer or Blob
                const chunkData = await firstValueFrom(this.http.get(fileUrl, {
                    headers: rangeHeader,
                    responseType: "blob"
                }));
                chunks.push(chunkData);
                start = end + 1;
                // Optional: Calculate and emit progress here if needed
                const progress = Math.round((start / totalSize) * 100);
                this.appController.showConsoleMessage(`Download progress: ${progress}%`);
            }
            // 3. Assemble chunks and trigger download
            const finalBlob = new Blob(chunks, { type: "application/octet-stream" });
            this.requestStatusService.removeBusySpinner("Download file");
            return finalBlob;
        }
        catch (error) {
            this.requestStatusService.removeBusySpinner("Download file");
            this.appController.handleServerErrorMessage(FileConstants.FILE_DOWNLOAD, error, CRUDOperation.Get);
        }
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: RequestStatusService },
        { type: HttpClient },
        { type: AuthService }
    ];
};
FileService = __decorate([
    Injectable({
        providedIn: "root"
    })
], FileService);
export { FileService };
